import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { getAntiIn, monitorSingleJsLoadTime } from '@/utils';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global';
import { asyncLoadFile } from '@/utils/asyncLoadFile';

export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['anti_in'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'] }) {
    const { url } = data
    const time = Date.now()
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadAntiIn' },
            value: Date.now() - time,
            message: 'anti-in load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime('antiin', JS_SERVER_TYPE[extra.env][extra.server_type]);
    })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadAntiInError' },
                value: Date.now() - time,
                message: 'anti-in load error',
                params: error
            })
        })
}

export async function headerOpenController(self: XMLHttpRequest, url: string, data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['anti_in']) {
    if (data?.hit?.some(path => url.includes(path))) {
        self._customHeaders = {
            ...self._customHeaders,
            'anti-in': 'anti-in'
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['anti-in']) {
        self.setRequestHeader('anti-in', await getAntiIn());
    }
}

